import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { api } from '@utils/api';
import Header from '@components/Header';
import Footer from '@components/Footer';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (!token) {
            setError('Token reset password tidak valid');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Password tidak cocok');
            return;
        }

        if (formData.password.length < 6) {
            setError('Password minimal 6 karakter');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(api('/api/auth/reset-password'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token,
                    password: formData.password,
                }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setSuccess(true);
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            } else {
                setError(data.message || 'Gagal reset password');
            }
        } catch (err) {
            setError('Terjadi kesalahan. Silakan coba lagi.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <Header />
            <main className="auth-container" style={{ maxWidth: '400px', margin: '120px auto', padding: '2rem' }}>
                <h2>Reset Password</h2>
                <p style={{ color: '#999', marginBottom: '1.5rem' }}>
                    Masukkan password baru Anda.
                </p>

                {success ? (
                    <div style={{ background: 'rgba(34, 197, 94, 0.1)', border: '1px solid #22c55e', borderRadius: '8px', padding: '12px', marginBottom: '1rem', color: '#22c55e' }}>
                        Password berhasil direset! Mengalihkan ke halaman login...
                    </div>
                ) : (
                    <>
                        {error && (
                            <div style={{ background: 'rgba(255, 107, 107, 0.1)', border: '1px solid #ff6b6b', borderRadius: '8px', padding: '12px', marginBottom: '1rem', color: '#ff6b6b' }}>
                                {error}
                            </div>
                        )}

                        {token && (
                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: '1rem' }}>
                                    <label style={{ display: 'block', marginBottom: '0.5rem', color: '#ccc' }}>Password Baru</label>
                                    <input
                                        type="password"
                                        value={formData.password}
                                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                        required
                                        style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(0,0,0,0.3)', color: '#fff' }}
                                    />
                                </div>

                                <div style={{ marginBottom: '1rem' }}>
                                    <label style={{ display: 'block', marginBottom: '0.5rem', color: '#ccc' }}>Konfirmasi Password</label>
                                    <input
                                        type="password"
                                        value={formData.confirmPassword}
                                        onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                                        required
                                        style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(0,0,0,0.3)', color: '#fff' }}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="auth-btn primary"
                                    style={{ width: '100%', padding: '0.75rem', marginTop: '1rem' }}
                                >
                                    {loading ? 'Memproses...' : 'Reset Password'}
                                </button>
                            </form>
                        )}
                    </>
                )}

                <div style={{ marginTop: '1.5rem', textAlign: 'center', color: '#999' }}>
                    <Link to="/login" style={{ color: '#d4af37', textDecoration: 'none' }}>
                        Kembali ke Login
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default ResetPassword;
